appComum.service("canalService", canalService);

canalService.$inject = ["$http"];

const SESSION_CANAL_KEY = "Comum.settings.canal";
function getCNPJ () {
  const sessionRHActivated = JSON.parse(sessionStorage.getItem(constants.SESSION.RH_ACTIVATED) || 'null');

  return sessionRHActivated?.cnpj;
}

function canalService($http) {
  /**
   * Retorna o data de canal
   *
   * @return Promise com os dados do canal de venda
   */
  function getCanal(cnpjRH) {
    return new Promise((resolve, reject) => {
      const cnpj = cnpjRH || getCNPJ();

      if(!cnpj) {
        reject();
      }

      const canais = JSON.parse(window.sessionStorage.getItem(SESSION_CANAL_KEY) || '{}');

      if(canais[cnpj]) {
        constants.SETTINGS.CANAL = canais[cnpj];

        resolve(constants.SETTINGS.CANAL);
      }

      $http({
        method: "GET",
        url: "/api-web/rh/dashboard/valida-canal-simule-compre",
        headers: {
          cnpjRH: cnpj,
        },
      }).success((res) => {
        constants.SETTINGS.CANAL.siglaCanal = res.siglaCanal ? res.siglaCanal.toLowerCase() : "default";
        constants.SETTINGS.CANAL.isSimuleCompre = res.canalSimuleCompre;
        constants.SETTINGS.CANAL.informacaoUltimoContrato = res.informacaoUltimoContrato || {};
        constants.SETTINGS.CANAL.nomeCanal = res.nomeCanal || "";

        canais[cnpj] = constants.SETTINGS.CANAL;

        window.sessionStorage.setItem(SESSION_CANAL_KEY, JSON.stringify(canais));

        resolve(constants.SETTINGS.CANAL);
      });
    })
  }

  function getSiglaCanal() {
    return new Promise((resolve) => {
      getCanal()
      .then(canal => resolve(canal.siglaCanal));
    });
  }

  return {
    getCanal: getCanal,
    getSiglaCanal: getSiglaCanal,
  };
}
